<template>
  <a-modal width="55%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
<!--    <a-button v-if="goodsType!=null && goodsType===20" type="primary"  @click="openScript(form.id)">
      库存定时任务
    </a-button>-->
    <a-form-model ref="form" :model="form"  :rules="rules">
      <a-form-item class="margin-bottom-10">
        <a-table :data-source="form.skuList" :columns="skuColumns" rowKey="id" :pagination="false" bordered>
          <div slot="addStock" slot-scope="text, record">
            <a-input-number v-model="record.addStock"  :placeholder="$t('请输入')+$t('商品库存')"  />
          </div>
          <div slot="skuStockTitle">
            {{$t('库存')}}
            <a-tooltip>
              <template slot="title">
                <p>实时库存 + 锁定中的库存 = 目前显示中的库存数</p>
                <p>如果不对,请点击下方修复库存</p>
              </template>
              <a-icon type="question-circle" />
            </a-tooltip>
          </div>
          <div slot="skuStock" slot-scope="text, record">
            <a-tooltip>{{ text }}
              <template slot="title">
                <p>实时库存{{ record.redisStock }}</p>
                <p>锁定中库存{{ record.lockStock }}</p>
              </template>
            </a-tooltip>
          </div>
        </a-table>
      </a-form-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
<!--    <stock-script ref="StockScript"></stock-script>-->
  </a-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import {getGoodsStock, repairGoodsStock, updateGoodsStock} from '@/api/goods/goods'
import CustomDictTag from "@/components/DictCustomTag";
import StockScript from "@/views/goods/goods/modules/StockScript.vue";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    StockScript,
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      errorMessage:undefined,
      skuColumns: [
        {
          title: this.$t('名称'),
          dataIndex: 'skuName',
          key: 'skuName',
        }, {
          title: this.$t('编码'),
          dataIndex: 'skuCode',
          key: 'skuCode',
        }, {
          title: this.$t('价格'),
          dataIndex: 'price',
          key: 'price',
        },
        {
          title: this.$t('原始库存'),
          width: 100,
          dataIndex: 'sourceStock',
          key: 'sourceStock',
        },
        {
          slots: { title: 'skuStockTitle' },
          width: 100,
          scopedSlots: {customRender: 'skuStock'},
          dataIndex: 'stock',
          key: 'stock',
        },
        {
          title: this.$t('增加/减少库存'),
          dataIndex: 'addStock',
          key: 'addStock',
          scopedSlots: {customRender: 'addStock'}
        }
      ],
      goodsType:null,
      // 表单参数
      form: {
        id: null,
        skuList: [],
        name: null,

        icon: null,

        color: null,

        status: 0,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        skuList: [],
        name: null,
        color: '#FFFFFF',
        icon: null,
        status: 0,
        createTime: null,
        remark: null,
      }
      this.goodsType=null
    },
    openScript(goodsId) {
      this.$refs.StockScript.handleUpdate(goodsId)
    },
    /** 修改按钮操作 */
    show(goodsId,goodsType) {
      this.reset()
      this.goodsType=goodsType
      this.formType = 2
      getGoodsStock({"id":goodsId}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改库存'
      })
    },
    stockRepair() {
      repairGoodsStock({"id":this.form.id,}).then(response => {
        this.$message.success(
          '库存修复成功',
          3
        )
        this.show(this.form.id,this.goodsType)
      })
    },

    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = this.$t('修改成功')
          updateGoodsStock(this.form).then(response => {
            this.$message.success(
              message,
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
